'use client';

import { JSX } from 'react';

interface IntercomChatLinkProps {
    children: React.ReactNode;
}

export default function IntercomChatLink({ children }: IntercomChatLinkProps): JSX.Element {
    const handleChatClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        if (typeof window !== 'undefined' && window.Intercom) {
            window.Intercom('show');
        }
    };

    return (
        <a
            href="#"
            className="text-blue-600 hover:underline"
            onClick={handleChatClick}
            aria-label="Open chat with customer support (opens Intercom chat window)"
        >
            {children}
        </a>
    );
}
